import React, { useContext, useEffect, useMemo } from 'react'
import cn from 'classnames'
import { Button, InterfaceStarFilledIcon } from '@grammarly/design-system'
import { navHelper } from '../../../lib/services/navigation'
import { useToolsLtvNav } from '../../../lib/hooks'
import { getConfig } from '../../../config'
import { CompactCtaContext } from '../../../contexts/compact-cta-context'
import ctaButtonStyles from '../../item/cta-button/cta-button.module.scss'
import styles from './trial-cta-button.module.scss'

const PLANS_URL = `${getConfig().urls.main}/plans`

const BUTTON_CONFIG = {
  trial: { text: 'Try Pro for free', variant: 'pro' as const, isInverted: false },
  upgrade: { text: 'Get Pro', variant: 'pro' as const, isInverted: true },
} as const

export const TrialCtaButton: React.FC = () => {
  const { isTrialEligible, trackShow } = useToolsLtvNav()
  const compact = useContext(CompactCtaContext)

  const config = useMemo(() => {
    return isTrialEligible ? BUTTON_CONFIG.trial : BUTTON_CONFIG.upgrade
  }, [isTrialEligible])

  useEffect(() => {
    trackShow()
  }, [trackShow])

  return (
    <div className={ctaButtonStyles.ctaContainer}>
      <div className={ctaButtonStyles.ctaButtonAndUnderLinkContainer}>
        <Button
          variant={config.variant}
          onClick={() => navHelper.navigateUrl(PLANS_URL)}
          size={compact ? 'small' : 'medium'}
          iconStart={InterfaceStarFilledIcon}
          text={config.text}
          className={cn({ [styles.invertedProButton]: config.isInverted })}
        />
      </div>
    </div>
  )
}
